<template>
  <v-row class=mx-0>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <template v-slot:activator="{ on, attrs }">

        <v-btn class="mx-0 px-0" :disabled="!isEditTitleAndMapStory" color="" v-bind="attrs" @click="waitFunction()" v-on="on" text>
          <v-icon color="primary" col=2 class="mx-0 px-0">mdi-map-marker</v-icon><span
            class="breakWord">{{pinnedPlace}}</span>
        </v-btn>


      </template>
      <v-card>
        <v-container>
          <v-row align="center" justify="end">
            <v-col cols=2 align="right">
              <v-btn large color="black" text @click="dialog = false" :icon="true">
                <i class="mdi mdi-chevron-left"></i>
              </v-btn>
            </v-col>
            <v-col cols=10>
              <span class="memexStoryTitle">{{cache.storyTitle}}</span>
            </v-col>

          </v-row>
          <v-row color="">
            <v-col cols=12>
              <v-icon color="black" class="mr-2">mdi-map-marker</v-icon><span
                class="breakWord darkorange--text uppercase--text">{{pinnedPlace}}</span>
            </v-col>

            <!--v-col cols="12" class="mt-0 pt-0 pb-0 px-0">
              <v-combobox :loading="isLoading" :search-input.sync="searchPosition" clearable dense rounded solo
                :items="items" item-text="text" item-value="id" v-model="searchInput"
                prepend-icon="mdi-map-marker-circle" class="px-5 mx-0"></v-combobox>
            </v-col-->
            <v-col cols="12" class="mt-0 pt-0 pb-2 px-0">

              <l-map ref="leafletmap" if="showMap" :zoom="zoom" :center="center" :options="mapOptions"
                @click="addMarker" style="position:absolute;bottom:0px;height: 75vh;z-index:2;" @update:center="centerUpdate"
                @update:zoom="zoomUpdate">
          <l-control position="bottomright">
            <v-btn class="floatingBtn mr-2"  fab small @click="changeCenterOfTheMapToUserPosition()">
              <img style="width:4vh;" :src="require('@/assets/center-map.png')" />
            </v-btn>
          </l-control>
          <l-control position="bottomright">
            <v-btn class="floatingBtn mr-2"  @click="dialog = false" color="primaryVariant" fab small >
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>
          </l-control>
          <l-control v-if="(showDirection!=null&&userLocation!=null)" position="bottomright">
                <v-btn class="floatingBtn" icon large>
                  <a
                    :href="'https://www.google.com/maps/dir/?api=1&origin=' + userLocation.lat + ',' + userLocation.lng + '&destination='+ showDirection.lat + ','+ showDirection.lng +'&travelmode=walking'">
                    <img style="width:4vh" :src="require('@/assets/direction.png')" />
                  </a>
                </v-btn>
          </l-control>


                <l-tile-layer :url="url" />
                <l-marker  v-if="markerLocation" :lat-lng="markerLocation">
                  <l-icon :iconSize="[40, 40]" :iconAnchor="[20, 40]" >
                    <v-icon x-large color="darkorange">mdi-map-marker</v-icon>
                  </l-icon>
                </l-marker>
                <!-- user position -->
                <l-marker v-if="userLocation" :lat-lng="userLocation">
                  <l-icon :iconSize="[30, 30]" :iconAnchor="[15, 30]">
                    <img width="30vh" :src="require('@/assets/account.png')" />
                  </l-icon>
                </l-marker>
              </l-map>
            </v-col>
          </v-row>
        </v-container>
        <!--v-footer :fixed="true" v-if="this.pinnedPlace&&dialog" class="pa-2 pt-0 mt-0">
          <v-container>
            <v-row v-if="pinnedPlace" align="center" style="width:100%" class="mt-0 pt-0 mb-0 pb-0">
              <v-col cols="9" class="px-0 mt-0 pt-0 mb-0 pb-0">
                <i v-if="this.pinnedPlace" class=" mdi mdi-map-marker"></i> {{this.pinnedPlace}}
              </v-col>

              <v-col cols="3" class="text-right mt-0 pt-0 mb-0 pb-0 px-0">
                <v-btn class="mr-0 pr-0 px-0" @click="saveCurrentStory()" text>{{$t("save")}}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-footer-->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  latLng
} from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LControl
} from "vue2-leaflet";
//import {EventBus} from "@/components/event-bus.js"
export default {
  name: "storyAddLocationContent",
  data: () => ({
    
    showDirection:null,
    getUserCoordinates: null,
    userLocation: null,
    markerLocation: null,
    dialog: false,
    apiUrl: process.env.VUE_APP_ROOT_API,
    searchInput: "",
    pinnedPlace: "",
    isLoading: false,
    searchData: null,
    items: [],
    storyTitle: '',
    staticAnchor: [16, 37],
    zoom: 15,
    center: latLng(44.8377720, 11.6186548),
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    currentZoom: 11.5,
    currentCenter: latLng(47.41322, -1.219482),
    showParagraph: false,
    mapOptions: {
      zoomSnap: 0.5
    },
    showMap: true,

    searchPosition: null
  }),
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControl
  },
  computed: {
    isEditTitleAndMapStory: {
      get: function () {
        return this.$store.getters.getIsEditTitleAndMapStory
      }
    },
    cache: {
      get: function () {
        return this.$store.getters.getNewStories
      },
      set: function (newValue) {
        this.$store.dispatch("setNewStories", newValue)
      }
    }
  },
  watch: {
    searchInput: function (value) {
      this.$refs.leafletmap.mapObject.setView(latLng(value.coordinates.lat, value.coordinates.lng), 8)
    },
    searchPosition(value) {
      if (value == null || value.length < 4) {
        this.items = []
        return
      }
      //isLoading
      if (this.isLoading)
        return
      this.isLoading = true
      this.addMarkerFromSearchbar()
      this.changeCenterOfTheMap(value).then(() => {
        this.isLoading = false
      })
    }
  },
  async mounted() {
    //check the current position of the user (for now it is associated with the user logged in the db)
      this.$getLocation()
  .then(response => {
    this.getUserCoordinates=response
    if(this.getUserCoordinates!=null){
      this.userLocation = {
        lat: this.getUserCoordinates.lat,
        lng: this.getUserCoordinates.lng
      }
    }
  });
  
      this.center = {lat: this.$store.getters.getUser.latitude,lng: this.$store.getters.getUser.longitude}



      let retrivePositionMarkerPlaceLatLng
    if (typeof this.cache.marker=="undefined"||this.cache.marker==null||this.cache.marker.lat==null||this.cache.marker.lng==null) {
      retrivePositionMarkerPlaceLatLng = {lat: this.$store.getters.getUser.latitude,lng: this.$store.getters.getUser.longitude}
      this.markerLocation = {lat: this.$store.getters.getUser.latitude,lng: this.$store.getters.getUser.longitude}
      this.cache.marker = {lat: this.$store.getters.getUser.latitude,lng: this.$store.getters.getUser.longitude}
    }else{
      retrivePositionMarkerPlaceLatLng={lat:this.cache.marker.lat,lng:this.cache.marker.lng}
      this.markerLocation={lat:this.cache.marker.lat,lng:this.cache.marker.lng}

    }

this.$getLocation()
  .then(response => {
    let coordinates=response
if (coordinates!=null&&typeof coordinates!="undefined"){
      this.userLocation = {
        lat: coordinates.lat,
        lng: coordinates.lng
      }
      if (this.markerLocation == null)
      this.markerLocation = this.userLocation
      if (this.cache.marker == null)
      this.cache.marker = this.userLocation
      if (this.center == null)
      this.center = this.userLocation
    }
  });
      let retrivePositionName = await this.retrivePositionMarkerPlace(retrivePositionMarkerPlaceLatLng)

      this.pinnedPlace = retrivePositionName.data.info
      this.cache.country = retrivePositionName.data.country
      this.cache.city = retrivePositionName.data.city
      this.saveCurrentStory();
  },

  methods: {
    waitFunction() {
      //this is a workaround for the map to load correctly since the leaflet component has a bug
      setTimeout(() => {
        this.$refs.leafletmap.mapObject.invalidateSize()
      }, 1000)
    },
    removeCurrentStoryMarker:async function() {
      this.marker = {
          'lat':  this.$store.getters.getUser.latitude,
          'lng': this.$store.getters.getUser.longitude
        };
      this.cache.marker = this.marker
      this.markerLocation = this.cache.marker
      let retrivePositionMarkerPlaceLatLng = this.$store.getters.getUser.longitude
      let retrivePositionName = await this.retrivePositionMarkerPlace(retrivePositionMarkerPlaceLatLng)
      this.pinnedPlace = retrivePositionName.data.info
      this.cache.country = retrivePositionName.data.country
      this.cache.city = retrivePositionName.data.city
      this.cache.marker =  {lat: this.$store.getters.getUser.latitude,lng: this.$store.getters.getUser.longitude}
    },
    retriveDataLocation: async function (searchLocation) {
      try {
        return this.getaxiosResponse(this.apiUrl + "/getLocations?place=" + searchLocation)
      } catch (error) {
        if (error.status === 400) {
          // Handle error.
        }
        // Handle error.
        else {
          // eslint-disable-next-line
          console.log(error);
        }
      }
    },
    retrivePositionMarkerPlace: async function (markerposition) {
      try {
        return this.getaxiosResponse(this.apiUrl + '/getGeoLocationInfo?lat=' + markerposition.lat + '&lon=' + markerposition.lng)
      } catch (error) {
        if (error.status === 400) {
          // Handle error.
        }
        if (error.status === 500) {
          // Handle error.
        }
        // Handle error.
        else {
          console.log(error);
        }
      }
    },
    //when i change te place i have to center the map in the new position
    changeCenterOfTheMap: async function (searchLocation) {
      try {
        let response = await this.retriveDataLocation(searchLocation)
        this.items = response.data
        this.currentZoom = 11.5
      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {
          //EventBus.$emit("spinner", "off");
          // eslint-disable-next-line
          console.log(error);
        }
      }
    },
    saveCurrentStory: function () {
      this.$nextTick()
      this.$store.dispatch("setNewStories", this.cache)
      this.dialog = false
    },
    removeMarker(index) {
      this.markers.splice(index, 1);
    },
/*    addMarkerFromSearchbar: async function () {
      try {
        this.marker = {
          'lat': this.searchInput.coordinates.lat,
          'lng': this.searchInput.coordinates.lng
        };
        this.cache.marker = this.marker
        this.markerLocation = this.cache.marker
        let retrivePositionName = await this.retrivePositionMarkerPlace(this.marker)
        this.pinnedPlace = retrivePositionName.data.info
        this.cache.country = retrivePositionName.data.country
        this.cache.city = retrivePositionName.data.city

      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {
          //EventBus.$emit("spinner", "off");
          // eslint-disable-next-line
          console.log(error);
        }
      }

    },*/

    addMarker: async function (event) {
      try {
        this.marker = {
          'lat': event.latlng.lat,
          'lng': event.latlng.lng
        };
        this.cache.marker = this.marker
        this.markerLocation = this.cache.marker
        let retrivePositionName = await this.retrivePositionMarkerPlace(this.marker)
        this.pinnedPlace = retrivePositionName.data.info
        this.cache.country = retrivePositionName.data.country
        this.cache.city = retrivePositionName.data.city

      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {
          //EventBus.$emit("spinner", "off");
          // eslint-disable-next-line
          console.log(error);
        }
      }

    },
    goToPage: function (page) {
      this.$router.push(page)
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    // center the map to user position
    changeCenterOfTheMapToUserPosition: function () {
      this.$refs.leafletmap.mapObject.setView(latLng(this.userLocation.lat, this.userLocation.lng), 11)
      //console.log("this.userLocation",this.userLocation)
    }
  }
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled .v-icon,.theme--light.v-btn.v-btn--disabled{
  color:#38737A!important;
  opacity: 1;
}
.mdi.mdi-chevron-left{
  font-size: 2rem;
}
.uppercase--text{
  text-transform: uppercase;
}
.breakWord{
  font-size: 65%;
     overflow-wrap: break-word;
     max-width: 40vh;
}
.leaflet-marker-icon {
  z-index: 9999;
}

.leaflet-control-attribution.leaflet-control a div.vue2leaflet-map:nth-child(1)>div:nth-child(4)>div:nth-child(4)>div:nth-child(1)>a:nth-child(1) .leaflet-control-attribution>a {
  display: none;
}
</style>